import React from 'react';
import { LocalizedLink } from '@repo/gatsby-localization-helpers';
import { useUiComponentsInternationalContext } from '@repo/static-translations';
import BreadcrumbArrow from './svgs/breadcrumb-arrow.svg';

interface BreadcrumbProps {
  elements: {
    link?: string;
    text: string;
  }[];
  useSVG?: boolean;
}

// Takes in array of {text, link} or {text} if last element
function Breadcrumb({ elements, useSVG = false }: Readonly<BreadcrumbProps>) {
  const { tt } = useUiComponentsInternationalContext();

  if (!elements || elements.length === 0) {
    return null;
  }

  return (
    <nav aria-label={tt(s => s.breadcrumbComponent.breadcrumbAriaLabel)}>
      <ol className="flex flex-row align-start items-center content-center flex-wrap gap-2 list-none p-0 m-0">
        {elements.map(({ text, link }, index) =>
          index === elements.length - 1 ? (
            // Last element
            <li key={text} className="text-foreground">
              <span>{text}</span>
            </li>
          ) : (
            // Middle elements
            <li key={text}>
              <LocalizedLink
                to={`${link}`}
                className="no-underline hover:underline"
              >
                {text}
              </LocalizedLink>
              {useSVG ? (
                <BreadcrumbArrow aria-hidden />
              ) : (
                <span aria-hidden className="text-foreground">
                  {' > '}
                </span>
              )}
            </li>
          )
        )}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
